<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Vtex \ <span class="ActiveURL">Product Price Upload</span></span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <span style="font-size:20px; font-weight:500" class="m-0">Product Price Upload</span>

        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
          style="margin-left: 400px;background-color:white;margin-top:-30px;color:black;" 
        </router-link> -->

        <button
            class="btn btn-md btn-primary"
            style="float:right; background-color:white; color:black;"
          >
          <download-excel :data="ProductMasterUpload.DataModel.UIData.VtexProductTemplate"   name="VtexProduct_Templates"><span style="marige-top:10px;" > Download Template </span>   </download-excel>  </button>


      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>
                 
               
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Product Master file *</label>
                    <div class="col-md-7" v-if="ProductMasterUpload.DataModel.UIData.UploadedDataCount == 0">   
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
                          <!-- :disabled="(ProductMasterUpload.DataModel.UIData.ProductMasterList.length == 0)" -->
                          <d-button type="button" id="submit" title="Please Select the panel"  class="btn-accent" :disabled="(ProductMasterUpload.DataModel.UIData.ProductMasterList.length == 0)" @click="ProductMasterUploadData" style="margin-right:10px" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="ProductMasterUpload.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ ProductMasterUpload.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>

                 <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.Data.SynccentricScrapList}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Rejected</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.UIData.RejectedList.length}}</label>
                    </div>
                 </d-col>


                <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Progressed</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.UIData.Progressed}}</label>
                    </div>
                 </d-col>
                
                <d-col md="12" class="form-group row"  v-if="(ProductMasterUpload.DataModel.UIData.Progressed == ProductMasterUpload.DataModel.UIData.ProductMasterList.length) && ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="ProductMasterUpload.DataModel.UIData.RejectedList"   :name="ProductMasterUpload.DataModel.UIData.RejectedFileName"><span style="marige-top:10px;" > Download Reject List </span> </download-excel>
                    </d-button>
                    </div>

<div class style="text-align:center"  v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>         

                  </d-col>

                <!-- <div class style="text-align:center"  v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>          -->
 

                </d-form-row>

                <br />

              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="ProductMasterUpload.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Base64 from "@/Utilities/Base64";
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
import $ from 'jquery'

export default {
  name: 'ProductMasterUpload',
   data() {
    return {
      ProductMasterUpload: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            ProductMaster:null,
            ProductMasterList:[],
            Token:null,
            Curd:null,
            CreatedBy:0
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            currentStep:0,
            Template:[],
            minMaxList:[],
            Progressed:0,
            RejectedList:[],
            AvailablityTemplate:[],
            RejectedFileName:null,
            ProductMasterList:[],
            ProductMasterList1:[],
            ProductMasterList2:[],
            ProductMasterList3:[],
            ProductMasterList4:[],
            ProductMasterList5:[],
            ProductMasterList6:[],
            ProductMasterList7:[],
            ProductMasterList8:[],
            ProductMasterList9:[],
            ProductMasterList10:[],
            AvailablityList:[],
            AvailablityTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0,
            VtexProductTemplate:[{
              _SkuId:0,
              _SkuName:null,	
              _ActivateSkuIfPossible:"Yes",	
              _SkuIsActive:"Yes",	
              _SkuEan:null,	
              _Height:null,	
              _ActualHeight:null,	
              _Width:null,	
              _ActualWidth:null,	
              _Length:null,	
              _ActualLength:null,	
              _Weight:null,	
              _ActualWeight:null,	
              _MeasurementUnit:null,	
              _UnitMultiplier:null,	
              _SKUReferenceCode:null,	
              _RewardValue:null,	
              _EstimatedDateArrival:null,	
              _ManufacturerCode:null,	
              _ProductId:null,	
              _ProductName:null,	
              _ProductShortDescription:null,	
              YES:null,	
              _ProductReferenceCodeId:null,	
              _ShowOnSite:null,	
              _CaptionLink:null,	
              _ProductDescription:null,	
              _ProductLaunchDate:null,	
              _Keywords:null,	
              _SiteTitle:null,	
              _MetaTagDescription:null,	
              _SupplierId:null,	
              _ShowOutOfStock:null,	
              _Kit:null,	
              _DepartmentId:null,	
              _DepartamentName:null,	
              _CategoryId:null,	
              _CategoryName:null,	
              _BrandId:null,	
              _Brand:null,	
              _CubicWeight:null,	
              _CommercialCondition:null,	
              _Stores:"1,2,3",	
              _Accessories:null,	
              _Similar:null,	
              _Suggestions:null,	
              _MostrarJunto:null,	
              _Attachment:null,	
              MainImage_URL:null,	
              AdditionalImages1_URL:null,	
              AdditionalImages2_URL:null,	
              AdditionalImages3_URL:null,	
              AdditionalImages4_URL:null,
            }]
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            }
          ]
        },
      },
    };
  },

  mounted(){
      this.ProductMasterUpload.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.ProductMasterUpload.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      // this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.ProductMasterUpload.DataModel.Data.FromCountry = null;
     this.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 0;
     this.ClearUsersetup();
     document.getElementById("pricing").reset();
},

panelOnchange(){

            this.ProductMasterUpload.DataModel.UIData.Template=[];
            this.ProductMasterUpload.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.ProductMasterUpload.DataModel.UIData.Template = [];
            this.ProductMasterUpload.DataModel.UIData.TemplateIsAvailable = false;
            this.ProductMasterUpload.DataModel.Data.SynccentricScrapList = 0;
            this.ProductMasterUpload.DataModel.UIData.UploadStatus = false;
            this.ProductMasterUpload.DataModel.UIData.ProductMasterList=[];
            // this.cleareList();
        this.ProductMasterUpload.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.ProductMasterUpload.DataModel.Data.FromCountry =null;
        this.ProductMasterUpload.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
      },

getQuery()
{
      let vm = this;
      vm.ProductMasterUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.ProductMasterUpload.DataModel.Data.Token = Token;
      this.ProductMasterUpload.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      var dataString = JSON.stringify(this.ProductMasterUpload.DataModel.Data);

      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.ProductMasterUpload.PageLoad = false;
            vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount= response.data.Result;
            // vm.UpDateProductMasterUploadsMaster();
            vm.$toaster.success("Task Comepeleted.");
          } else {

          }
        })
        .catch(function (response) {
          // console.log(response);
            vm.ProductMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},

        ProductMasterUploadData(){
           this.getQuery()
  
        this.ProductMasterUpload.DataModel.UIData.UploadStatus = true;
        
      },

  // UploadedDataCount

 
 

  NameCorrection(str){
var ActualName="";
// var str="_books Publishing, BT_birthday Gifts for nurses";
var res = str.split("|");

if(res.length == 1){
    
    var name =  res[0].split(",");
    if(name.length==1)
        ActualName += name[0];
    else
        ActualName += name[1]+" "+name[0];
}
else{
  
  for(var i=0;i<res.length;i++)
  {
    var name =  res[i].split(",");
       if(name.length>0)
        ActualName += name[1]+" "+name[0];

        if(i!=(res.length-1))
        ActualName += " | "
  }
}

if(ActualName == null)
{
    ActualName="";
}
 console.log(ActualName);
return ActualName;
// document.getElementById("demo1").innerHTML = ActualName;
},


  LanguageCorrection(str){
var ActualName="";
// var str="_books Publishing, BT_birthday Gifts for nurses";
var res = str.split(">>");

if(res.length == 1){
        ActualName = res[0];
}
else{
  for(var i=0;i<res.length;i++)
  {
       if(i==0)
        ActualName =res[0];
  }
}

if(ActualName == null)
{
    ActualName="";
}
console.log(ActualName);
return ActualName;
// document.getElementById("demo1").innerHTML = ActualName;
},


    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */
     importExcel(e) {

      const files = e.target.files;
      this.ProductMasterUpload.PageLoad = true;
      this.ProductMasterUpload.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.ProductMasterUpload.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000


          this.ProductMasterUpload.DataModel.Data.SynccentricScrapList = 0 ;
          this.ProductMasterUpload.DataModel.Data.QueryString = "insert into VtexProductcatalogTemp(`SkuName`,`ActivateSkuIfPossible`,`SkuIsActive`,`SkuEan`,`Height`,`ActualHeight`,`Width`,`ActualWidth`,`Length`,`ActualLength`,`Weight`,`ActualWeight`,`MeasurementUnit`,`UnitMultiplier`,`SKUReferenceCode`,`RewardValue`,`EstimatedDateArrival`,`ManufacturerCode`,`ProductName`,`ProductShortDescription`,`YES`,`ProductReferenceCodeId`,`ShowOnSite`,`CaptionLink`,`ProductDescription`,`ProductLaunchDate`,`Keywords`,`SiteTitle`,`MetaTagDescription`,`SupplierId`,`ShowOutOfStock`,`Kit`,`DepartmentId`,`CategoryId`,`BrandId`,`CubicWeight`,`CommercialCondition`,`Stores`,`Accessories`,`Similar`,`Suggestions`,`x`,`Attachment`,`MainImage_URL`,`AdditionalImages1_URL`,`AdditionalImages2_URL`,`AdditionalImages3_URL`,`AdditionalImages4_URL`,`BulletPoint_36`,`BulletPoint_37`,`BulletPoint_38`,`BulletPoint_39`,`BulletPoint_40`,`Color_71`,`Size_72`,`UpcEAN_57`,`Weight_58`,`Dimensions_60`,`PartNo_59`,`Condition_70`,`ISBN_10_73`,`Author_74`,`Publisher_75`,`Format_76`,`Pages_77`,`Language_78`,`CreatedBy`) VALUES";
          this.ProductMasterUpload.DataModel.UIData.ProductMasterList = [];

          // this.cleareList();
          // for (var i = 0; i < loopCount; i++) {

          // }


          for (var i = 0; i < ws.length; i++) {

            var PriceDetails=
            {
                ASIN:null,
                Category:0,	
                Weight:0,	
                buybox_new_landed_price:0,	
                Panel:null,	
                buybox_seller:null,	
                UAE_Quantity:0,
                USA_Quantity:0,	
                India_Quantity:0,
                CreatedBy:0

            }

  

            if(ws[i].ASIN!=undefined)	
                PriceDetails.ASIN = ws[i].ASIN;
            else
                PriceDetails.ASIN ="";
  
     if(ws[i].Category!=undefined)	
                PriceDetails.Category = ws[i].Category;
            else
                PriceDetails.Category ="";
  
  if(ws[i].Weight!=undefined)	
                PriceDetails.Weight = ws[i].Weight;
            else
                PriceDetails.Weight ="";
  
   if(ws[i].buybox_new_landed_price!=undefined)	
                PriceDetails.buybox_new_landed_price = ws[i].buybox_new_landed_price;
            else
                PriceDetails.buybox_new_landed_price ="";
  
     if(ws[i].Panel!=undefined)	
                PriceDetails.Panel = ws[i].Panel;
            else
                PriceDetails.Panel ="";
  
     if(ws[i].buybox_seller!=undefined)	
                PriceDetails.buybox_seller = ws[i].buybox_seller;
            else
                PriceDetails.buybox_seller ="";
  
     if(ws[i].UAE_Quantity!=undefined)	
                PriceDetails.UAE_Quantity = ws[i].UAE_Quantity;
            else
                PriceDetails.UAE_Quantity ="";
  
     if(ws[i].USA_Quantity!=undefined)	
                PriceDetails.USA_Quantity = ws[i].USA_Quantity;
            else
                PriceDetails.USA_Quantity ="";
  
     if(ws[i].India_Quantity!=undefined)	
                PriceDetails.India_Quantity = ws[i].India_Quantity;
            else
                PriceDetails.India_Quantity ="";
  
     
            var EmptyValue = null;
            PriceDetails.CreatedBy = this.ProductMasterUpload.SessionInfo.PageInfo.userId;
            // console.log("(\"" + SKUDetails.Name + "\",\"" + ProductMaster.IsActive + "\",\"" + SKUDetails.IsActive + "\",\"" + SKUEan.SKUean + "\",\"" + SKUDetails.PackagedHeight + "\",\"" + SKUDetails.PackagedHeight + "\",\"" + SKUDetails.PackagedWidth + "\",\"" + SKUDetails.PackagedWidth + "\",\"" + SKUDetails.PackagedLength + "\",\"" + SKUDetails.PackagedLength + "\",\"" + SKUDetails.PackagedWeightKg + "\",\"" + SKUDetails.PackagedWeightKg + "\",\"" + SKUDetails.MeasurementUnit + "\",\"" + SKUDetails.UnitMultiplier + "\",\"" + SKUDetails.RefId + "\"," + EmptyValue + "," + EmptyValue + ",\"" + SKUDetails.ManufacturerCode + "\",\"" + ProductMaster.Name + "\",\"" + ProductMaster.DescriptionShort + "\",\"" + EmptyValue + "\",\"" + ProductMaster.RefId + "\",\"" + EmptyValue + "\",\"" + ProductMaster.LinkId + "\",\"" + ProductMaster.Description + "\",\"" + new Date() + "\",\"" + ProductMaster.KeyWords + "\",\"" + ProductMaster.Title + "\",\"" + ProductMaster.Description + "\",\"" + ProductMaster.SupplierId + "\"," + EmptyValue + "," + EmptyValue + ",\"" + ProductMaster.DepartmentId + "\",\"" + ProductMaster.CategoryId + "\",\"" + ProductMaster.BrandId + "\",\"" + SKUDetails.CubicWeight + "\",\"" + SKUDetails.CommercialConditionId + "\"," + EmptyValue + "," + EmptyValue + "," + EmptyValue + "," + EmptyValue + "," + EmptyValue + "," + EmptyValue + ",\"" + ws[i].MainImage_URL + "\",\"" + ws[i].AdditionalImages1_URL + "\",\"" + ws[i].AdditionalImages2_URL + "\",\"" + ws[i].AdditionalImages3_URL + "\",\"" + ws[i].AdditionalImages4_URL + "\",\"" + ws[i].BulletPoint_36 + "\",\"" + ws[i].BulletPoint_37 + "\",\"" + ws[i].BulletPoint_38 + "\",\"" + ws[i].BulletPoint_39 + "\",\"" + ws[i].BulletPoint_40 + "\",\"" + ws[i].Color_71 + "\",\"" + ws[i].Size_72 + "\",\"" + ws[i].UpcEAN_57 + "\",\"" + ws[i].Weight_58 + "\",\"" + ws[i].PartNo_59 + "\",\"" + ws[i].Dimensions_60 + "\",\"" + ws[i].Condition_70 + "\",\"" + ws[i].ISBN_10_73 + "\",\"" + ws[i].Author_74 + "\",\"" + ws[i].Publisher_75 + "\",\"" + ws[i].Format_76 + "\",\"" + ws[i].Pages_77 + "\",\"" + ws[i].Language_78 + "\",\"" + this.ProductMasterUpload.SessionInfo.PageInfo.userId + "\",\"" + new Date() + "\")");

            

            this.ProductMasterUpload.DataModel.Data.QueryString = this.ProductMasterUpload.DataModel.Data.QueryString + "(\"" + SKUDetails.Name + "\",\"" + ProductMaster.IsActive + "\",\"" + SKUDetails.IsActive + "\",\"" + SKUEan.SKUean + "\",\"" + SKUDetails.PackagedHeight + "\",\"" + SKUDetails.PackagedHeight + "\",\"" + SKUDetails.PackagedWidth + "\",\"" + SKUDetails.PackagedWidth + "\",\"" + SKUDetails.PackagedLength + "\",\"" + SKUDetails.PackagedLength + "\",\"" + SKUDetails.PackagedWeightKg + "\",\"" + SKUDetails.PackagedWeightKg + "\",\"" + SKUDetails.MeasurementUnit + "\",\"" + SKUDetails.UnitMultiplier + "\",\"" + SKUDetails.RefId + "\"," + EmptyValue + "," + EmptyValue + ",\"" + SKUDetails.ManufacturerCode + "\",\'" + ProductMaster.Name + "\',\'" + ProductMaster.DescriptionShort + "\',\"" + EmptyValue + "\",\"" + ProductMaster.RefId + "\",\"" + EmptyValue + "\",\"" + ProductMaster.LinkId + "\",\'" + ProductMaster.Description + "\',\"" + EmptyValue + "\",\'" + ProductMaster.KeyWords + "\',\'" + ProductMaster.Title + "\',\'" + ProductMaster.Description + "\'," + ProductMaster.SupplierId + "," + EmptyValue + "," + EmptyValue + ",\"" + ProductMaster.DepartmentId + "\",\"" + ProductMaster.CategoryId + "\",\"" + ProductMaster.BrandId + "\",\"" + SKUDetails.CubicWeight + "\",\"" + SKUDetails.CommercialConditionId + "\"," + EmptyValue + "," + EmptyValue + "," + EmptyValue + "," + EmptyValue + "," + EmptyValue + "," + EmptyValue + ",\"" + ws[i].MainImage_URL + "\",\"" + ws[i].AdditionalImages1_URL + "\",\"" + ws[i].AdditionalImages2_URL + "\",\"" + ws[i].AdditionalImages3_URL + "\",\"" + ws[i].AdditionalImages4_URL + "\",\'" + ws[i].BulletPoint_36 + "\',\'" + ws[i].BulletPoint_37 + "\',\'" + ws[i].BulletPoint_38 + "\',\'" + ws[i].BulletPoint_39 + "\',\'" + ws[i].BulletPoint_40 + "\',\'" + ws[i].Color_71 + "\',\'" + ws[i].Size_72 + "\',\'" + ws[i].UpcEAN_57 + "\',\'" + ws[i].Weight_58 + "\',\'" + ws[i].Dimensions_60 + "\',\'" + ws[i].PartNo_59 + "\',\"" + ws[i].Condition_70 + "\",\'" + ws[i].ISBN_10_73 + "\',\'" + ws[i].Author_74 + "\',\'" + ws[i].Publisher_75 + "\',\'" + ws[i].Format_76 + "\',\'" + ws[i].Pages_77 + "\',\'" + ws[i].Language_78 + "\',\"" + this.ProductMasterUpload.SessionInfo.PageInfo.userId + "\")";

              

            if(i < (ws.length - 1))
            {
              this.ProductMasterUpload.DataModel.Data.QueryString = this.ProductMasterUpload.DataModel.Data.QueryString+"," 
            }
            this.ProductMasterUpload.DataModel.Data.SynccentricScrapList +=1;
            
              ProductBO.ProductMaster = Utilities.JsonCopy(ProductMaster);
              ProductBO.SKUDetails = Utilities.JsonCopy(SKUDetails);
              ProductBO.SKUEan = Utilities.JsonCopy(SKUEan);
              ProductBO.ImageList = Utilities.JsonCopy(ImageList);
              ProductBO.BulletPoints = Utilities.JsonCopy(BulletPoints);


            this.ProductMasterUpload.DataModel.UIData.ProductMasterList.push(Utilities.JsonCopy(ProductBO));

      
          }
          // console.log(this.ProductMasterUpload.DataModel.Data.QueryString);

            // console.log(this.ProductMasterUpload.DataModel.UIData.ProductMasterList);
          
          //  this.ProductMasterUpload.DataModel.Data.QueryString = this.ProductMasterUpload.DataModel.Data.QueryString+";"
          // console.log("Read results", this.ProductMasterUpload.DataModel.Data.SynccentricScrapList); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          // console.log('headers', this.ProductMasterUpload.DataModel.Data.SynccentricScrapList);  
          this.ProductMasterUpload.PageLoad = false;
          //  console.log(this.ProductMasterUpload.DataModel.Data.QueryString); 
          // this.ProductMasterUpload.DataModel.Data.QueryString = JSON.stringify(this.ProductMasterUpload.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            this.ProductMasterUpload.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },


countSpecial(str){
  try{
  if(str!=null && str!="" && str!=undefined && isNaN(str))
    {
      str = str.replace(/'/g, "\\\'");
      // str = Base64.encode(str);
    }
  }
  catch(ex)
  {
    console.log(ex);
    console.log(str);
  }
  
   return str;
},

 previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       }


  }
}
</script>

